// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class CustomFieldOptions {
  readonly label: string;
  readonly value: unknown;

  constructor(data: { [key: string]: any } = {}) {
    this.label = data.label === undefined ? '' : data.label;
    this.value = data.value === undefined ? null : data.value;
  }

  static zero(): CustomFieldOptions {
    const zeroValues: ExcludeMethodsDeep<CustomFieldOptions> = {
      label: '',
      value: null,
    };
    return new CustomFieldOptions(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CustomFieldOptionsWireFormat = {
  label: string;
  value: unknown;
};

type NewCustomFieldOptionsProps = PartialDeep<CustomFieldOptions, { recurseIntoArrays: true }>;
export const NewCustomFieldOptions: (props: NewCustomFieldOptionsProps) => CustomFieldOptions = (
  props,
) => new CustomFieldOptions(props);

type NewCustomFieldOptionsFromWireFormatProps = PartialDeep<
  CustomFieldOptionsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCustomFieldOptionsFromWireFormat: (
  props: NewCustomFieldOptionsFromWireFormatProps,
) => CustomFieldOptions = (props) => new CustomFieldOptions(props);
